import styled from 'styled-components';
import { getColor } from 'core/utils/Styles';

export const SmallPrint = styled.p`
	margin: 9px 0;
	color: ${getColor('gray8')};
	text-align: center;
	font-size: 8px;
`;

export const Link = styled.a`
	color: ${getColor('darkTeal')};
	text-decoration: none;
`;
